import { render } from "./Main.vue?vue&type=template&id=733d0e96&scoped=true&ts=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=733d0e96&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733d0e96"]])

export default __exports__